/**
 * Devolver a condicional: o cliente trouxe a peça de volta depois de decidir
 * não comprar. Motivo é OPCIONAL — ao contrário do cancelamento, que exige
 * de 3 a 500 caracteres porque é um erro operacional que precisa de registro
 * (ver `DialogoCancelarCondicional.tsx` e `docs/de-para.md`, "Cancelar e
 * devolver fazem o mesmo trabalho no banco").
 */
import { useState, type FormEvent } from 'react'

import { Dialogo, RodapeDoDialogo } from '../../componentes/Dialogo'
import { MensagemDeErro } from '../../componentes/Campos'
import { ErroApi } from '../../plataforma/api'
import {
  devolverCondicional,
  TAMANHO_MAXIMO_MOTIVO_DEVOLUCAO,
  type Condicional,
  type LinhaCondicional,
} from '../../plataforma/condicional'

export function DialogoDevolverCondicional({
  condicional,
  aoFechar,
  aoConcluir,
}: {
  condicional: LinhaCondicional
  aoFechar: () => void
  aoConcluir: (atualizada: Condicional) => void
}) {
  const [motivo, setMotivo] = useState('')
  const [erro, setErro] = useState('')
  const [enviando, setEnviando] = useState(false)

  async function enviar(evento: FormEvent) {
    evento.preventDefault()
    setErro('')
    setEnviando(true)
    try {
      const atualizada = await devolverCondicional(condicional.codigo, motivo)
      aoConcluir(atualizada)
    } catch (causa: unknown) {
      setErro(causa instanceof ErroApi ? causa.message : 'Não foi possível devolver a condicional.')
      setEnviando(false)
    }
  }

  return (
    <Dialogo
      icone="apparel"
      titulo={`Devolver ${condicional.codigo}?`}
      descricao={`A peça volta ao estoque de ${condicional.cliente.nome}. Não dá para desfazer.`}
      aoFechar={aoFechar}
    >
      <form onSubmit={enviar} noValidate>
        <label htmlFor="motivo-devolucao" className="mb-2 block text-[13px] font-semibold text-texto">
          Motivo (opcional)
        </label>
        <textarea
          id="motivo-devolucao"
          rows={3}
          maxLength={TAMANHO_MAXIMO_MOTIVO_DEVOLUCAO}
          value={motivo}
          onChange={(evento) => setMotivo(evento.target.value)}
          placeholder="Ex.: não serviu, trocou de ideia…"
          className="campo w-full px-3 py-2 text-[13.5px]"
        />

        {erro && <MensagemDeErro>{erro}</MensagemDeErro>}

        <RodapeDoDialogo
          confirmar="Devolver peça"
          confirmando="Devolvendo…"
          ocupado={enviando}
          aoCancelar={aoFechar}
        />
      </form>
    </Dialogo>
  )
}
